<div class="container mt-4">

    <!-- Head -->
    <div class="row justify-content-center">
        <div class="col-md-7 col-xl-5 text-end">

            <div class="dropdown">
                <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">{{ user.username || user.displayName }}</a>

                <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <li><a class="dropdown-item" [routerLink]="['/profile/edit']">Editar perfil</a></li>
                    <li><a class="dropdown-item" href="javascript:void(0)" (click)="logout()">Cerrar sesión</a></li>
                </ul>
            </div>

        </div>
    </div>

</div>